import React from 'react';
import { Avatar, Typography } from '@mui/material';
import './TestimonialCards.css';

const TestimonialCard = ({ testimonial }) => (
  <div className="testimonial-card">
    <div className="testimonial-content">
      <div className="testimonial-header">
        <Avatar className="avatar" aria-label="testimonial avatar">
          {testimonial.avatarLetter || 'A'}
        </Avatar>
        <Typography variant="h6" className="name">
          {testimonial.name}
        </Typography>
      </div>
      {testimonial.brief && (
        <Typography variant="body2" className="testimonial-brief">
          {testimonial.brief}
        </Typography>
      )}
      {testimonial.screenshot && (
        <img
          src={testimonial.screenshot}
          alt={`${testimonial.name} offer testimonial screenshot`}
          className="testimonial-screenshot"
          loading="lazy"
        />
      )}
    </div>
  </div>
);

export default TestimonialCard;